import { render, staticRenderFns } from "./pre_btn_no_new.vue?vue&type=template&id=2a8c2b6e&scoped=true"
import script from "./pre_btn_no_new.vue?vue&type=script&lang=js"
export * from "./pre_btn_no_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c2b6e",
  null
  
)

export default component.exports